import "../assets/style/components/Viewer.scss";
import * as Icon from 'react-bootstrap-icons';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../components/Carousel";

const Viewer = ({ article, isOpen, isNew, toggleViewer}) => {
   return (
        <div className={`viewer ${isOpen ? 'open' : ''}`}>
            <div className="viewer-container">
                <div className={`p-0`}>
                    <Carousel item={article} />
                </div>
                <div className="viewer-body">
                    <h3 className="card-title">{article.title}</h3>
                        <div className="pill-container">
                            {isNew && <div className="pill primary-action primary-text"><Icon.Bell size={15} />Dernière nouveauté</div>}
                            {article.category && <div className="pill"><Icon.Tag size={15} />{article.category}
                        </div>}
                    </div>
                    <p className={`card-text`}>{article.text}</p>
                    <div className="card-footer">
                        <div>
                            <div className="lightItalic">Publié le {new Date(article.date).toLocaleDateString()}</div>
                            <div className="lightItalic">{article.forename} {article.name}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`viewer-overlay ${isOpen ? 'visible' : ''}`} />
            <button className={`viewer-btn ${isOpen ? 'visible' : ''}`} onClick={()=>toggleViewer('')}><Icon.X /></button>
        </div>
    )
}

export default Viewer;